import axios from "@axios";

import { getPartnerViewIdsForGroups, getSiteIdsForGroups } from "@/utils/store";

const DEFAULT_STATE = {
  monthDate: "",
  sites: [],
  siteGroups: [],
  audienceType: "ga",
  rwmData: {},
  partnersViews: [],
  partnerViewGroups: [],
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getMonthDate: (state) => state.monthDate,
    getSites: (state) => state.sites,
    getSiteGroups: (state) => state.siteGroups,
    getAudienceType: (state) => state.audienceType,
    getRwmData: (state) => state.rwmData,
    getPartnerViewGroups: (state) => state.partnerViewGroups,
    getPartnerViews: (state) => state.partnersViews,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setMonthDate(state, payload) {
      state.monthDate = payload;
    },
    setSites(state, payload) {
      state.sites = payload;
    },
    setSiteGroups(state, payload) {
      state.siteGroups = payload;
    },
    setAudienceType(state, payload) {
      state.audienceType = payload;
    },
    setRwmData(state, payload) {
      state.rwmData = payload;
    },
    setPartnerViews(state, payload) {
      state.partnersViews = payload;
    },
    setPartnerViewGroups(state, payload) {
      state.partnerViewGroups = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updateMonthDate({ commit }, payload) {
      commit("setMonthDate", payload);
    },
    updateSites({ commit }, payload) {
      commit("setSites", payload);
    },
    async updateSiteGroups({ commit }, payload) {
      commit("setSiteGroups", payload);

      const siteIds = await getSiteIdsForGroups(payload);
      commit("setSites", siteIds);

      return siteIds;
    },
    updateRwmData({ commit }, payload) {
      commit("setRwmData", payload);
    },
    updateAudienceType({ commit }, payload) {
      commit("setAudienceType", payload);
    },
    async getRwmData({ commit }, payload) {
      const response = await axios.get("/audience/rwm-data", {
        params: payload,
      });
      commit("setRwmData", response.data);
    },
    updatePartnerViews({ commit }, payload) {
      commit("setPartnerViews", payload);
    },
    async updatePartnerViewGroups({ commit }, payload) {
      commit("setPartnerViewGroups", payload);
      if (!payload.length) {
        commit("setPartnerViews", []);
        return;
      }

      const partner_views_ids = await getPartnerViewIdsForGroups(payload);
      commit("setPartnerViews", partner_views_ids);

      return partner_views_ids;
    },
  },
};
